// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"b50c7299","147":"d885293f","262":"b3601e53","348":"8402b2ae","411":"c2f3354c","414":"f4a1fa2e","453":"61756ef0","949":"77b8a3ae"}[chunkId] + ".chunk.js";
};